// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsApiSettingsInfoDatatableAppGroupIdResult = objectOf({
  name: string,
  key: string,
  created_at: number,
  last_used_utc_date: number,
  created_by_developer_email: maybe(string),
  io: maybe(boolean),
  is_client_key: boolean,
});
